import React from 'react';

const Footer = (props)=>{
    return(
        <section className="footer inner">
            <p className = "footerText">Copyright © takashima takuto, All rights reserved.</p>
        </section>
    )
}


export default Footer;